module.exports = __webpack_public_path__ + "img/1531782134.24e7cd0f.jpg";